"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCharacterHurtboxShapes = void 0;
var realms_engine_1 = require("realms-engine");
/**
 * Gets a characters hitbox shapes
 */
function createCharacterHurtboxShapes() {
    var height = 15;
    var radius = 4;
    var cylinderHeight = height - 2 * radius;
    var cylinder = new realms_engine_1.CANNON.Cylinder(radius, radius, cylinderHeight);
    var sphereTop = new realms_engine_1.CANNON.Sphere(radius);
    var sphereBottom = new realms_engine_1.CANNON.Sphere(radius);
    return [
        { shape: cylinder },
        { shape: sphereTop, position: { x: 0, y: cylinderHeight / 2, z: 0 } },
        {
            shape: sphereBottom,
            position: { x: 0, y: (-1 * cylinderHeight) / 2, z: 0 },
        },
    ];
}
exports.createCharacterHurtboxShapes = createCharacterHurtboxShapes;
